import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/693780d25a24100014120458_1785105078243_8603ee6e/grammar_drill_engine/src/app/drill-configuration/page.tsx");
